module.exports = __webpack_public_path__ + "img/112.6.3333589f.png";